import { useStableCallback } from '@rocket.chat/fuselage-hooks';
import type { FormEvent } from 'react';
import { useMemo, forwardRef } from 'react';

import { Input } from '../InputBox';

import type { PaginatedSelectProps } from './PaginatedSelect';
import { PaginatedSelect } from './PaginatedSelect';

export type PaginatedSelectFilteredProps = Omit<
  PaginatedSelectProps,
  'setFilter'
> & {
  setFilter: (value: string | undefined | number) => void;
};

const PaginatedSelectFiltered = ({
  filter,
  setFilter,
  options,
  placeholder,
  ...props
}: PaginatedSelectFilteredProps) => {
  const anchor = useMemo(
    () =>
      forwardRef<HTMLInputElement, PaginatedSelectFilteredProps>(
        ({ filter, onChange: _onChange, ...props }, ref) => (
          <Input
            mi={4}
            flexGrow={1}
            className='rcx-select__focus'
            ref={ref}
            placeholder={placeholder}
            value={filter}
            onChange={useStableCallback((e: FormEvent<HTMLInputElement>) => {
              setFilter(e.currentTarget.value);
            })}
            {...props}
            rcx-input-box--undecorated
          />
        ),
      ),
    [placeholder, setFilter],
  );

  return (
    <PaginatedSelect
      placeholder={undefined}
      filter={filter}
      options={options}
      {...props}
      anchor={anchor}
    />
  );
};

export default PaginatedSelectFiltered;
